// Generated by Melange

import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(isActive) {
  return function (route) {
    return function (activeIconOpt) {
      const activeIcon = activeIconOpt !== undefined ? Caml_option.valFromOption(activeIconOpt) : null;
      return function (iconOpt) {
        const icon = iconOpt !== undefined ? Caml_option.valFromOption(iconOpt) : null;
        return function (title) {
          const match = React.useState(function () {
                return false;
              });
          const setHovered = match[1];
          return JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                      route: route,
                      className: Cn.fromList({
                            hd: "px-6 flex py-1.5 group",
                            tl: {
                              hd: isActive ? "bg-white/8" : "hover:bg-white/8",
                              tl: /* [] */0
                            }
                          }),
                      children: [
                        isActive || match[0] ? activeIcon : icon,
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: Cn.fromList({
                                    hd: Cn.on("ml-4", icon !== null),
                                    tl: {
                                      hd: isActive ? "text-white" : "text-gray-medium group-hover:text-white",
                                      tl: /* [] */0
                                    }
                                  }),
                              children: title
                            })
                      ],
                      onMouseEnter: (function (param) {
                          Curry._1(setHovered, (function (param) {
                                  return true;
                                }));
                        }),
                      onMouseLeave: (function (param) {
                          Curry._1(setHovered, (function (param) {
                                  return false;
                                }));
                        })
                    });
        };
      };
    };
  };
}

function SidebarNestedItem(Props) {
  return Curry._3(make(Props.isActive)(Props.route), Props.activeIcon, Props.icon, Props.title);
}

const make$1 = SidebarNestedItem;

export {
  make$1 as make,
}
/* Buhta_cabinet__Link Not a pure module */
